import styled from 'styled-components';
import appTheme from '../../../themes/Theme';
import { Color } from '../../../constants/Color';

export const StyledWrapper = styled.h3`
  color: ${appTheme.textColor};
  font-size: ${(props) => props.isSmall ? '16px' : (props.fontSize + 'px')};

  :hover a {
    display: inline-block;
  }

  a {
    text-decoration: none;
    margin-left: 4px;
    font-size: ${(props) => props.isSmall ? '16px' : (props.fontSize + 'px')};
    color: ${Color.PuertoRico};
    display: none;

    :hover {
      text-decoration: underline;
    }
  }
`;
